const getAdditionalItem = activeVariantEl => {
  const additionalProductId = +activeVariantEl.getAttribute('data-additional-product-id');
  const quantity = 1;
  let additionalSellingPlan = null;
  if (activeVariantEl.hasAttribute('data-additional-selling-plan-id')) {
    additionalSellingPlan = +activeVariantEl.getAttribute('data-additional-selling-plan-id');
  }

  return [additionalProductId, quantity, additionalSellingPlan];
};

const buildPdpCartItems = (form, variantId, quantity, sellingPlan) => {
  const activeVariantEl = form.querySelector('[data-active-variant]');

  if (activeVariantEl?.hasAttribute('data-additional-product-id')) {
    const [additionalProductId, additionalQuantity, additionalSellingPlan] =
      getAdditionalItem(activeVariantEl);
    return [
      { id: variantId, quantity, sellingPlan },
      {
        id: additionalProductId,
        quantity: additionalQuantity,
        sellingPlan: additionalSellingPlan,
      },
    ];
  }

  return [{ id: variantId, quantity, sellingPlan }];
};

export default buildPdpCartItems;
